import React__default from 'react';
import { a as CardStyled } from './Card.styles-f559f5b9.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-12ae0974.js';

const CardContainer = ({
  taktId,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  fallbackId: createStormTaktId('card')
}, /*#__PURE__*/React__default.createElement(CardStyled, restProps));
var CardContainer$1 = CardContainer;

export { CardContainer$1 as C };
//# sourceMappingURL=CardContainer-03c515ec.js.map
